import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { SupportedPaymentMethodTypeFeeStateEntity } from './supported-payment-method-type-fee-state.entity';
import { SupportedPaymentMethodTypeStateEntity } from './supported-payment-method-type-state.entity';

@Index('IDX_paymentMethodType', ['paymentMethodType'], {})
@Index(
	'IDX_paymentMethodType_deletedDate',
	['paymentMethodType', 'deletedDate'],
	{},
)
@Entity('supported_payment_method_type')
export class SupportedPaymentMethodTypeEntity extends BaseEntity {
	@Column('varchar', { name: 'paymentMethodType', length: 64 })
	public paymentMethodType!: string;

	@Column('enum', { name: 'processingFeeType', enum: ['%', '$'] })
	public processingFeeType!: '%' | '$';

	@Column('decimal', {
		name: 'processingFee',
		precision: 10,
		scale: 2,
		default: 0,
	})
	public processingFee!: number;

	@OneToMany(
		() => SupportedPaymentMethodTypeFeeStateEntity,
		(supportedPaymentMethodTypeFeeState) =>
			supportedPaymentMethodTypeFeeState.fkSupportedPaymentMethodType,
		{},
	)
	public supportedPaymentMethodTypeFeeStates!: Array<SupportedPaymentMethodTypeFeeStateEntity>;

	@OneToMany(
		() => SupportedPaymentMethodTypeStateEntity,
		(supportedPaymentMethodTypeState) =>
			supportedPaymentMethodTypeState.fkSupportedPaymentMethodType,
		{},
	)
	public supportedPaymentMethodTypeStates!: Array<SupportedPaymentMethodTypeStateEntity>;
}
